export default "__VITE_ASSET__DmDMgYtR__"